import React from "react";
import { ExcelForm } from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelForm";
import ExcelUploader from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelUploader";
import { ExcelGrid } from "../components/UI/reusable-components/ExcelProductPageComponents/ExcelGrid";
import { Box } from "@mui/material";

export const  ExcelProductPage =  () => {

    return(
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
  {/* Üst kısım: Form + Uploader yan yana */}
  <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3 , mt: 5}}>
    <ExcelForm />
    <ExcelUploader onFilesChange={(files) => console.log(files)} />
  </Box>

  {/* Alt kısım: Grid */}
  <ExcelGrid />
</Box>
    

)
}
